import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface HelpIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function HelpIcon({ color = RoutalPalette.secondary60, style = {} }: HelpIconProps) {
  return (
    <SvgIcon viewBox="0 0 12 13" fill="none" style={{ fill: `none`, height: `17px`, width: `16px`, ...style }}>
      <g>
        <path
          d="M6 11.1838C8.76142 11.1838 11 8.94526 11 6.18384C11 3.42241 8.76142 1.18384 6 1.18384C3.23858 1.18384 1 3.42241 1 6.18384C1 8.94526 3.23858 11.1838 6 11.1838Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.54504 4.68385C4.6626 4.34968 4.89462 4.0679 5.20002 3.88841C5.50542 3.70893 5.86449 3.64332 6.21363 3.7032C6.56277 3.76309 6.87945 3.94461 7.10758 4.21561C7.33571 4.48661 7.46057 4.82961 7.46004 5.18385C7.46004 6.18385 5.96004 6.68385 5.96004 6.68385"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 8.68384H6.005" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
}
